import { LicenseAgreementById } from '../../app/api/user'
import { UserRole } from '../../types/organization'
import type { LicenseAgreement } from '../../types/user'
import { ADMIN_ROLE_PERMISSIONS, EDITOR_ROLE_PERMISSIONS } from '../permissions'

import { LOREM_IPSUM_MARKDOWN } from './lorem'

export const LICENSES: LicenseAgreement[] = [
	{
		id: 1,
		version: '1',
		name: 'Hello License',
		effectiveFrom: '1970-01-01T00:00:00.000Z',
	},
	{
		id: 2,
		version: '2022.11.29',
		name: 'Lorem Ipsum',
		effectiveFrom: '2022-11-29T00:00:00.000Z',
	},
]

export const LICENSE_TEXTS: Record<number, LicenseAgreementById> = {
	1: {
		id: 1,
		accepted: false,
		effectiveFrom: '1970-01-01T00:00:00.000Z',
		licenseText: 'Hello world',
		name: 'Hello License',
		version: '1',
	},
	2: {
		id: 2,
		accepted: false,
		effectiveFrom: '2022-11-29T00:00:00.000Z',
		licenseText: LOREM_IPSUM_MARKDOWN,
		name: 'Lorem Ipsum',
		version: '4',
	},
}

export const USER_AGREEMENTS: {
	accepted: LicenseAgreement[]
	missing: LicenseAgreement[]
} = {
	accepted: [],
	missing: [LICENSES[0]],
}

export const AUTHORIZED_USER = {
	id: '1',
	email: 'mocked.user@example.com',

	// if there is no field at all, then the user is considered anonymous (the check of permissions breaks)
	isAnonymous: false,
	// isAnonymous: true,
}

export const AUTHORIZED_USER_PERMISSIONS = {
	organizations: [
		{
			id: '1',
			role: UserRole.admin,
			permissions: ADMIN_ROLE_PERMISSIONS,
		},
		{
			id: '2',
			role: UserRole.editor,
			permissions: EDITOR_ROLE_PERMISSIONS,
		},
	],
	projects: [],
	teams: [],
}
